export default __webpack_public_path__ + "static/media/PHK市中心.49b4aa1e.jpg";